module.exports = __webpack_public_path__ + "static/media/dc_two2.b0728ff8.jpg";